import analyticsHelper from '.';

export default {
  // This function is called when the Vue plugin is installed
  install(app) {
    analyticsHelper.init();
    const globalProperties = app.config?.globalProperties || app.prototype;
    globalProperties.$analytics = analyticsHelper;
    // Add a shorthand function for the track method on the helper module
    globalProperties.$track = analyticsHelper.track.bind(analyticsHelper);
  },
};
